import { BaseService } from "../baseService";
import { SubPurchaseOrderAPIService, GetSubPurchaseOrdersQueryParams } from "./subPurchaseOrderAPIService";
import { sanitiseParams } from "src/utils/sanitiser";
import { PaginatedSubPurchaseOrders } from "src/types";
import { PopulatedSubPurchaseOrder } from "src/types/database";

class SubPurchaseOrderService extends BaseService<SubPurchaseOrderAPIService> {
  @sanitiseParams()
  async getSubPurchaseOrders(queryParams: GetSubPurchaseOrdersQueryParams): Promise<PaginatedSubPurchaseOrders> {
    return await this.apiService.getSubPurchaseOrders(queryParams);
  }

  async getSubPurchaseOrderById(id: string): Promise<PopulatedSubPurchaseOrder> {
    return await this.apiService.getSubPurchaseOrderById(id);
  }
}

export { SubPurchaseOrderService };
